import { ProcedureStepCompletionStatus } from "../../enums/procedures"
import { FilterModifier } from "./FilterModifier"

export const ProcedureStepCompletionStatusEqualsFilterModifier = FilterModifier.create<
	ProcedureStepCompletionStatus,
	ProcedureStepCompletionStatus
>({
	id: "procedure-step-completion-status-equals",
	getApplyFn: (filterValue) => (value) => {
		return value === filterValue
	},
	render: () => "is",
	serialize: (filterValue) => filterValue,
	deserialize: (filterValue) => filterValue,
})

export const ProcedureStepCompletionStatusNotEqualsFilterModifier = FilterModifier.create<
	ProcedureStepCompletionStatus,
	ProcedureStepCompletionStatus
>({
	id: "procedure-step-completion-status-not-equals",
	getApplyFn: (filterValue) => (value) => {
		return value !== filterValue
	},
	render: () => "is not",
	serialize: (filterValue) => filterValue,
	deserialize: (filterValue) => filterValue,
})

export const ProcedureStepCompletionStatusIncludesFilterModifier = FilterModifier.create<
	ProcedureStepCompletionStatus,
	ProcedureStepCompletionStatus[]
>({
	id: "procedure-step-completion-status-includes",
	getApplyFn: (filterValue) => {
		const filterValueSet = new Set(filterValue)
		return (value) => {
			return filterValueSet.has(value)
		}
	},
	render: () => "is any of",
	serialize: (filterValue) => filterValue,
	deserialize: (filterValue) => filterValue,
})

export const ProcedureStepCompletionStatusExcludesFilterModifier = FilterModifier.create<
	ProcedureStepCompletionStatus,
	ProcedureStepCompletionStatus[]
>({
	id: "procedure-step-completion-status-excludes",
	getApplyFn: (filterValue) => {
		const filterValueSet = new Set(filterValue)
		return (value) => {
			return !filterValueSet.has(value)
		}
	},
	render: () => "is none of",
	serialize: (filterValue) => filterValue,
	deserialize: (filterValue) => filterValue,
})
